export default function filterDisabledQueues<TQueue extends { isDisabled?: boolean; Name: string }>({
  allQueues,
  disabledQueuePrefix,
}: {
  allQueues: TQueue[];
  disabledQueuePrefix?: string;
}): TQueue[] {
  return allQueues.filter((queue) => {
    if (queue.isDisabled) {
      return false;
    }

    return disabledQueuePrefix ? !queue.Name.startsWith(disabledQueuePrefix) : true;
  });
}
